import React from 'react';
import { colors } from '../../constants/theme';
import { mockData } from '../../data/mockData';

const PhaseSelector = ({ selectedPhase, onPhaseChange }) => {
  const phaseLabels = {
    grupos: 'Fase de Grupos',
    quartas: 'Quartas de Final',
    semifinal: 'Semifinal',
    final: 'Final'
  };

  return (
    <div className="flex justify-center space-x-2 mb-4">
      {mockData.phases.map((phase) => (
        <button
          key={phase}
          onClick={() => onPhaseChange(phase)}
          className={`px-4 py-2 rounded-lg font-medium ${
            selectedPhase === phase ? 'text-white' : 'bg-white text-gray-700'
          }`}
          style={{
            backgroundColor: selectedPhase === phase ? colors.primary : 'white'
          }}
        >
          {phaseLabels[phase]}
        </button>
      ))}
    </div>
  );
};

export default PhaseSelector;